<template>
    <div style="width: 100%; height: 100%">
        <cgs-echarts ref="cgsEcharts" 
            v-if="config.chartType !== 'numberGraphic' && worksheetData.length > 0"
            :type="config.chartType" 
            :title='config.name'
            :x='Array.isArray(config.xAxis)? config.xAxis: [{field: config.xAxis}]'
            :data='worksheetData'
            :y='config.yAxis'
            :colors='config.colorConfig'
            :limits='config.colorLimit'
            :cutlineFontSize='config.cutlineFontSize'
            :chartUnit='config.chartUnit'
            :scrollBar='config.scrollBar'
        />
        <cgs-number-graphic ref="cgsNumberGraphic" 
            v-if="config.chartType === 'numberGraphic' && worksheetData.length > 0"
            :title="config.name"
            :unit="config.numberStyle.unit"
            :font-size="config.numberStyle.fontSize"
            :font-color="config.numberStyle.fontColor"
            :decimal-point="config.numberStyle.decimalPoint"
            :data="worksheetData"
            :y="config.yAxis"
        />
    </div>
</template>

<script>
import cgsEcharts from "./cgsEcharts.vue"
import cgsNumberGraphic from "./cgsNumberGraphic.vue"
import {getShareFilterDataList} from "@/api/application"
export default {
    props: {config:Object},
    components:{
        cgsEcharts,
        cgsNumberGraphic,
    },
    data(){
        return {
            id: "cgsTest_" + new Date().getTime(),
            numberData: 0,
            numberStyle: {},
            worksheetData: [],
            oldConfig: null,
        }
    },
    async mounted() {
        this.getWorksheetData()
    },
    watch:{
        config: {
            deep: true,
            async handler(value) {
                if(this.config.type !== 'chart') return
                if(this.oldConfig !== JSON.stringify(value)){
                    this.oldConfig = JSON.stringify(value)
                    this.getWorksheetData()
                }
            }
        }
    },
    methods: {
        async getWorksheetData() {
            const { worksheetId, sortField, filters, isAsc, filterTable, max_rowData } = this.config
            let _filters = [...filters]
            if (filterTable) { 
                _filters = Array.isArray(filterTable) ? [...filters, ...filterTable] : [...filters, filterTable]
            }
            let filterData = {
                worksheetId,
                sortField,
                filters: _filters,
                isAsc,
                format: 1,
            }
            if(max_rowData){
                filterData.pageNo = 1
                filterData.pageSize = max_rowData
            }
            if(!filterData.sortField){
                filterData.sortField = 'updateTime'
            }
            let data = await getShareFilterDataList(filterData)
            this.worksheetData = data?.data || []
        },
        resize(newHPx, newWPx) {
            if (this.config.chartType !== 'numberGraphic' && this.$refs['cgsEcharts']) {
                this.$refs['cgsEcharts'].resize(newHPx, newWPx)
            }
        }
    }
}
</script>

<style scoped>
.sceen3d{
    width: 100%;
    height: 100%;
}
</style>